import React, { useEffect } from 'react'
import HomeTop from './HomeTop'
import HomeFooter from './HomeFooter'
import { Button, Grid } from '@mui/material'
// import { useNavigate } from "react-router-dom";


function AdminFeatures() {
    // const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
      }, []);
      
    return (
        <>
            <HomeTop />

            <div className='adminBannerMain whiteBG'>
                <div className='container'>
                    <div className='adminBannerContent'>
                        <h1>Admin Features</h1>
                        <p>The Admin Module offers comprehensive control over community operations, managing resident information, maintenance requests, and resident communication efficiently. It features intuitive dashboards and automated workflows for streamlined financial oversight and event scheduling, ensuring smooth society management.</p>
                    </div>
                </div>
            </div>

            <div className='sectionMain'>
                <div className='innerPagesFeaturesOuter'>
                    <div className='container'>
                        <div className='innerPagesFeaturesInner'>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Society Configuration</h3>
                                        <p>Add society details such as Buildings, Wings, Society Image,  Documents, Google Map, Layout. </p>
                                     
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Profile Management</h3>
                                        <p>Update Admin and Society details such as Name, Contact Number, Address, Email Id, Building Count, Documents.</p>
                                      
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Resident Management</h3>
                                        <p>Add Resident and Tenant details such as Name, Contact Number, Email Id, Age, Apartment, Family Details, Vehicle Details, Documents.</p>
                                  
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Visitor Management</h3>
                                        <p>Keep a track of all the visitors entering the society premises in real time.</p>
                               
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Security Management</h3>
                                        <p>Add Guards, Security Spots and Assign Duty to the guards.</p>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Committee Members</h3>
                                        <p>Add members of the society committee with their designation.</p>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                    <h3>Service Providers Management</h3>
                                        <p>Add Service Providers with their details such as Name, Contact Number, Age, Service Type.</p>
                                       
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Support Tickets</h3>
                                        <p>Raise Support Tickets on behalf of the Residents along with the attachments.</p>
       
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                    <h3>Invoice Management</h3>
                                        <p>Create, Save and Send Invoices to the Residents on the go.</p>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Manage SOS</h3>
                                        <p>Create SOS alerts.</p>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Notice board</h3>
                                        <p>Create, Save and Publish society related notices.</p>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Discussion Forum</h3>
                                        <p>Initiate a conversation for discussing society related issues.</p>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Events</h3>
                                        <p>Create upcoming society events.</p>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Complaints</h3>
                                        <p>Keep a track of the complaints raised by the Residents.</p>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Polls</h3>
                                        <p>Conduct society polls for getting valuable feedback from the Residents.</p>
                                    
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className='featureOuter'>
                                        <h3>Notifications</h3>
                                        <p>Get important notifications related to the society.</p>
                                    </div>
                                </Grid>
                            </Grid>
                           
                        </div>
                    </div>
                </div>

            </div>

            <div className='contactFormMain'>
                <div className='sectionMain'>
                    <div className='container'>
                        <div className='contactForm'>
                            <h1 className='sectionHeading' style={{ color: '#ffffff' }}>Connect With Us</h1>
                            <Grid container spacing={4}>
                                <Grid item xs={12} md={4}>
                                    <input
                                        className="contactInput"
                                        placeholder="Enter name"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <input
                                        className="contactInput"
                                        placeholder="Enter mobile number"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <input
                                        className="contactInput"
                                        placeholder="Enter email id"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <input
                                        className="contactInput"
                                        placeholder="Enter society name"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <input
                                        className="contactInput"
                                        placeholder="Select Location"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <input
                                        className="contactInput"
                                        placeholder="Enter City"
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Button className='contactBtn'>Submit</Button>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>

            <HomeFooter />
        </>
    )
}

export default AdminFeatures